import { useState, useEffect } from "react";

// COMPONENTS
import { DefaultButton, HorizontalLine, Icons } from "components/atoms";
//
import { useSelector } from "react-redux";
import { userSelector } from "store/models/userInfo";
import {
  deleteDrinkCategory,
  updateDrinkCategory,
} from "api/drinkCategory/drinkCategory";
import { Drink } from "components";
import { createDrink } from "api/drink/drink";
import { positionDown, positionUp } from "api/position";
import { findFont } from "helpers/findDataCustom";
import { focusInput } from "../../../helpers/focusInput";

export function DrinkCreationPatron({
  drinkCategory,
  drinkCategoryId,
  menuSectionName,
  loadData = () => {},
  custom,
  setLoading,
  index,
  length,
  volumes,
}) {
  const { user } = useSelector(userSelector);

  const changeDrinkCategory = async (data) => {
    await updateDrinkCategory(drinkCategoryId, data);
  };

  const sendDrink = async () => {
    const { data } = await createDrink(user.token, drinkCategoryId);
    await loadData();
    focusInput("drink", data.drink.id);
  };

  const removeDrinkCategory = async () => {
    await deleteDrinkCategory({ id: drinkCategoryId, token: user.token });
    loadData();
  };

  const changePosition = async (section, action) => {
    setLoading(true);
    if (action === "up") {
      await positionDown(section.id, "drinkcategory");
    }

    if (action === "down") {
      await positionUp(section.id, "drinkcategory");
    }
    loadData();
    setLoading(false);
  };

  return (
    <div key={drinkCategoryId} id={`drink-category-${drinkCategoryId}`}>
      <div className="relative md:mb-8 ">
        <div className="mt-8 ">
          <div className=" flex flex-col md:flex-row ">
            <div className="flex flex-row basis-3/5 w-full  ">
              <div className="flex flex-col  w-full h-[80px]">
                <div className="flex flex-col-reverse md:flex-row md:justify-between items-end w-full h-full relative max-w-[624px]">
                  <input
                    className={` my-1 border rounded  border-solid border-grey-disabled py-5 md:py-2.5 placeholder-grey-disabled bg-transparent pl-4 lg:max-w-[600px] w-full md:w-4/5 h-7/12 text-sm sm:text-base truncate
                    ${custom && findFont(custom.police[2].custom.fontFamily)}
                    ${custom && custom.police[2].custom.bold && "font-bold"}
                    ${custom && custom.police[2].custom.italic && "italic"}`}
                    placeholder="Nom de la sous-categorie"
                    defaultValue={drinkCategory.name}
                    onBlur={(e) =>
                      changeDrinkCategory({ name: e.target.value.trim() })
                    }
                    name={`drink-category-${drinkCategoryId}`}
                    style={{
                      fontSize: custom && custom.police[2].custom.fontSize,
                      letterSpacing:
                        custom && custom.police[2].custom.letterSpacing,
                      color: custom && custom.color[2].custom.color,
                    }}
                  ></input>
                  <div className=" mb-2 min-h-[40px] justify-center gap-5 md:gap-0 items-col flex flex-row md:items-center items-end ">
                    <div className="flex flex-col items-center">
                      {length !== 1 && (
                        <>
                          {index != 0 && (
                            <Icons
                              name="arrow-up"
                              height="20"
                              className="md:mr-5 hover:opacity-50 active:opacity-100"
                              onClick={() =>
                                changePosition(drinkCategory, "up")
                              }
                              style={{
                                color: custom && custom.color[1].custom.color,
                              }}
                            />
                          )}
                          {index + 1 != length && (
                            <Icons
                              name="arrow-down"
                              height="20"
                              className="md:mr-5 hover:opacity-50 active:opacity-100"
                              onClick={() =>
                                changePosition(drinkCategory, "down")
                              }
                              style={{
                                color: custom && custom.color[1].custom.color,
                              }}
                            />
                          )}
                        </>
                      )}
                    </div>
                    <Icons
                      name="trash"
                      height="20"
                      onClick={() => {
                        removeDrinkCategory();
                      }}
                      className="md:px-0"
                      style={{ color: custom && custom.color[1].custom.color }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              style={{ color: custom && custom.color[2].custom.color }}
              className="block md:hidden text-xs  md:text-left text-center text-grey-disabled md:mb-0 mb-4 md:pl-2"
            >
              (ex: vins rouges, vins blancs, vins rosés,...)
            </p>
            <div className="flex justify-start basis-2/5   items-end  md:justify-end  md:items-start ">
              {volumes &&
                Object.keys(volumes).map(
                  (key) =>
                    volumes[key] && (
                      <div
                        className="lg:w-20 md:w-[68px] w-1/5 h-20 flex flex-col  justify-end gap-2 md:items-center items-center"
                        style={{
                          color: custom && custom.color[2].custom.color,
                        }}
                      >
                        <Icons
                          name={`drink${key}`}
                          height={
                            {
                              "15cl": "28",
                              "25cl": "32",
                              "37,5cl": "48",
                              "50cl": "40",
                              "75cl": "64",
                            }[key]
                          }
                          className={
                            {
                              "15cl": "w-3",
                              "25cl": "w-4",
                              "37,5cl": "w-3",
                              "50cl": "w-10",
                              "75cl": "w-4",
                            }[key]
                          }
                          style={{
                            color: custom && custom.color[2].custom.color,
                          }}
                        />
                        <p
                          className="text-xs md:text-base md:mx-0 ml-4 mr-[15px]"
                          style={{
                            color: custom && custom.color[1].custom.color,
                          }}
                        >
                          {key}
                        </p>
                      </div>
                    )
                )}
            </div>
          </div>
          <p
            style={{ color: custom && custom.color[2].custom.color }}
            className="hidden md:block text-xs  md:text-left text-center text-grey-disabled md:mb-0 mb-4 md:pl-2  "
          >
            (ex: vins rouges, vins blancs, vins rosés,...)
          </p>
        </div>

        {drinkCategory.Drink.map((drink) => (
          <Drink
            drink={drink}
            drinkId={drink.id}
            volumes={volumes}
            custom={custom}
            loadData={loadData}
          />
        ))}
        <DefaultButton
          onClick={() => {
            sendDrink();
          }}
          className=" md:mt-12 mt-8 m-auto"
        >
          Ajouter un{" "}
          {menuSectionName === "Vins"
            ? menuSectionName
                .toLowerCase()
                .substring(0, menuSectionName.length - 1)
            : menuSectionName.toLowerCase()}
        </DefaultButton>
      </div>
    </div>
  );
}
